import React, {useState, useEffect} from "react";
import { InputCheckBox, InputText, SelectDropdown, InputTimeBlock, InputDateBlock, TextArea } from "commons/input-controls";
import { StandartButton } from "commons/form-controls";
import { ReactComponent as SaveIcon } from "assets/icons/save.svg";
import moment from "moment";
import s from "./changelog-item.module.scss";


const ChangelogItem = (props) => {

    const versionRegExp = /^(?:0|[1-9][0-9]{0,2})(?:\.(?:0|[1-9][0-9]{0,2})){0,2}$/;

    const getFieldsName = (fields) => {
        let fieldsList = fields.map(k =>    {   return {
                                                    name: k.name ? props.getValue(k.name) : props.getValue(k), 
                                                    title: k.name ? k.name : k, 
                                                    list: k.list ? k.list : k
                                                }
                                            });
        return fieldsList;
    }

    const getTime = (date) => {
        let time = {}
        time.h = moment(date).format('H');
        time.m = moment(date).format('m');
        return time
    }

    const getDate = (date) => {
        let time = {}
        time.d = moment(date).format('DD');
        time.m = moment(date).format('MM');
        time.y = moment(date).format('YYYY');
        return time
    }

    const [content, setContent] = useState(props.changeLog && props.changeLog.content ? props.changeLog.content : '');
    const [contentKk, setContentKk] = useState(props.changeLog && props.changeLog.contentKk ? props.changeLog.contentKk : '');
    const [contentEn, setContentEn] = useState(props.changeLog && props.changeLog.contentEn ? props.changeLog.contentEn : '');
    const [releaseTag, setReleaseTag] = useState(props.changeLog && props.changeLog.releaseTag ? props.changeLog.releaseTag : '');
    const [notificationType, setNotificationType] = useState(props.changeLog && props.changeLog.notificationType ? props.changeLog.notificationType : 'NEW_FEATURE');
    const [notificationTypes, setNotificationTypes] = useState(getFieldsName(props.notificationsTypes));
    const [incidentTime, setIncidentTime] = useState(getTime(props.changeLog && props.changeLog.incidentTime ? props.changeLog.incidentTime : moment()));
    const [incidentDate, setIncidentDate] = useState(getDate(props.changeLog && props.changeLog.incidentTime ? props.changeLog.incidentTime : moment()));
    const [isShowOnly, setIsShowOnly] = useState(props.showOnly);
    const [parameters, setParameters] = useState(props.changeLog ? props.changeLog : {}); 
    const [versionError, setVersionError] = useState(null);
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        setContent(props.changeLog && props.changeLog.content ? props.changeLog.content : '');
        setContentKk(props.changeLog && props.changeLog.contentKk ? props.changeLog.contentKk : '');
        setContentEn(props.changeLog && props.changeLog.contentEn ? props.changeLog.contentEn : '');
        setNotificationType(props.changeLog && props.changeLog.notificationType ? props.changeLog.notificationType : 'NEW_FEATURE');
        setNotificationTypes(getFieldsName(props.notificationsTypes));
        setReleaseTag(props.changeLog && props.changeLog.releaseTag ? props.changeLog.releaseTag : '');
        setIncidentTime(getTime(props.changeLog && props.changeLog.incidentTime ? props.changeLog.incidentTime : moment()));
        setIncidentDate(getDate(props.changeLog && props.changeLog.incidentTime ? props.changeLog.incidentTime : moment()));
        setIsShowOnly(props.showOnly);
        setParameters(props.changeLog ? props.changeLog : {});
    }, [props])

    const setDateNumber = (index, value, type) => {
        if(type === 'day'){
            let d = value < 10 ? 0+''+value : value
            let t = {d: d, m: incidentDate.m, y: incidentDate.y}
            setIncidentDate(t)
        }
        else if(type === 'month'){
                let m = value < 10 ? 0+''+value : value
                let t = {d: incidentDate.d, m: m, y: incidentDate.y}
                setIncidentDate(t)
        }
        else if(type === 'year'){
            let y = value < 10 ? 0+''+value : value
            let t = {d: incidentDate.d, m: incidentDate.m, y: y}
            setIncidentDate(t)
        }
        setRerender(!rerender);
    }

    const setNumber = (index, value, type) => {
        if(type === 'first'){
            let h = value
            
            let t = {h: h, m: incidentTime.m}
            setIncidentTime(t)
        }
        else if(type === 'second'){
                let m = value
                let t = {h: incidentTime.h, m: m}
                setIncidentTime(t)
        }
        setRerender(!rerender);
    }

    const getFormatedDate = (date) => {
        return getFormatDate(moment(date).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ssZ')//moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
    }

    const saveChangeLog = () => {
        //2025-09-09T14:17:00.000Z
        let h = incidentTime.h < 10 ? 0+""+incidentTime.h : incidentTime.h;
        let m = incidentTime.m < 10 ? 0+""+incidentTime.m : incidentTime.m;
        let dateTime = incidentDate.y+'-'+incidentDate.m+'-'+incidentDate.d+'T'+h+':'+ m+":00.000Z";
        let param = {
            notificationType: notificationType,
            content: content,
            contentKk: contentKk,
            contentEn: contentEn,
            releaseTag: releaseTag
        };
        param.incidentTime = dateTime;
        setParameters(param)
        let release = param.releaseTag;
        if(release && !release.match(versionRegExp)){
            setVersionError(props.getValue("RELEASE_TAG_ERROR_MESSAGE"));
        }
        else{
            //selectedLanguage, changeLogId, parameters, currentPage, showedItemsCount
            setVersionError(null)
            if(props.type === 'create')
                props.createChangelog(props.selectedLanguage, param, props.currentPage, props.showedItemsCount)
            else if(props.type === 'edit') {
                props.updateChangelog(props.selectedLanguage, props.changeLog.id, param, props.currentPage, props.showedItemsCount)
            }
            props.closeRightMenu();
        }
        
    }

    const setContentParameter = (e) => {
        setContent(e);
        setRerender(!rerender);
    }

    const setContentKkParameter = (e) => {
        setContentKk(e);
        setRerender(!rerender);
    }

    const setContentEnParameter = (e) => {
        setContentEn(e);
        setRerender(!rerender);
    }

    const setReleaseTagParameter = (e) => {
        setReleaseTag(e);
        setRerender(!rerender);
    }

    const setNotificationsTypesParameter = (e) => {
        setNotificationType(e.list);
        setRerender(!rerender);
    }

    const checkSaveButton = () => {
        if(content || contentKk || contentEn){
            if(notificationType !== 'TECH_WORK' && !releaseTag){
                return true
            }
            else return false
            
        }
        else
            return true
    }

    return (
        <div className={s.ChangelogItem}>
            <div className="formRow">
                <div className="labelText">{props.getValue('content')+" "+props.getValue('RUSSIAN')}</div>
                <TextArea height={14} rows={9} value={content} readOnly={isShowOnly} callback={setContentParameter}/>
            </div>
            <div className="formRow">
                <div className="labelText">{props.getValue('content')+" "+props.getValue('KAZAKH')}</div>
                <TextArea height={14} rows={9} value={contentKk} readOnly={isShowOnly} callback={setContentKkParameter}/>
            </div>
            <div className="formRow">
                <div className="labelText">{props.getValue('content')+" "+props.getValue('ENGLISH')}</div>
                <TextArea height={14} rows={9} value={contentEn} readOnly={isShowOnly} callback={setContentEnParameter}/>
            </div>
            <div className="formRow">
                <div className="labelText">{props.getValue('notificationType')}</div>
                <SelectDropdown items={notificationTypes} selected={props.getValue(notificationType)} showOnly={isShowOnly} setSelected={setNotificationsTypesParameter}/>
            </div>
            {notificationType && notificationType !== 'TECH_WORK' ? <div className="formRow">
                <InputText error={versionError} value={releaseTag} readOnly={isShowOnly} callback={setReleaseTagParameter} labelText={props.getValue('releaseTag')} hideRedStar={true}/>
            </div> : null}
            {notificationType && notificationType === 'TECH_WORK' ? <div className="formRow">
                <div className="labelText">{props.getValue('incidentTime')}</div>
                <div>
                    {<InputDateBlock readOnly={isShowOnly} values={incidentDate} name={'date'} callback={setDateNumber} maxFirst={31} minFirst={1} maxSecond={12} minSecond={1} maxThird={2030} minThird={2020}/>}
                </div>
                <br />
                <div>
                    {<InputTimeBlock readOnly={isShowOnly} values={incidentTime} name={'hour'} callback={setNumber} maxFirst={23} minFirst={0} maxSecond={59} minSecond={0}/> }
                </div>     
            </div> : null }
            {!props.showOnly ? <div className="formRow">
                <StandartButton disabled={checkSaveButton()} title={props.getValue("SAVE")} icon={SaveIcon} fill={'white'} callback={saveChangeLog}/>
            </div> : null}
        </div>
    )
}

export default ChangelogItem;